import React from 'react'
import { Card, CardBody, Col } from 'reactstrap'
import ReactApexChart from 'react-apexcharts'
import DropdownWithHeader from '../../../../Utils/CommonComponents/DashboardsCommon/DropdownWithHeader'
import { groupChartOption, monthlyDropdownList } from '../../../../Data/DashboardsData/ECommerceData'
import { SalesReportTitle } from '../../../../Utils/Constants'
import { LI, UL } from '../../../../AbstractElements'

export default function SalesReport() {
    return (
        <Col md={6} className="box-col-8e">
            <Card>
                <DropdownWithHeader headerClass='pb-0' heading={SalesReportTitle}
                    dropDownClass='icon-dropdown' dropDownIcon dropDownList={monthlyDropdownList} />
                <CardBody className="position-relative p-0">
                    <div className="group-legend">
                        <UL className='simple-list flex-row'>
                            <LI className="me-3">
                                <div className="circle bg-primary me-1" /><span>Sales Account</span>
                            </LI>
                            <LI>
                                <div className="circle bg-secondary me-1" /><span>General Leads </span>
                            </LI>
                        </UL>
                    </div>
                    <div id="groupBarChart">
                        <ReactApexChart type='bar' options={groupChartOption} series={groupChartOption.series} height={325} />
                    </div>
                </CardBody>
            </Card>
        </Col>
    )
}